export default "__VITE_ASSET__Wytg9eKx__"